<template>
    <div class="banner-wrapper">
      <div class="banner-content" :style="{ animationDuration: duration + 's' }">
        <span
          v-for="(item, index) in repeatedItems"
          :key="index"
          class="banner-item"
        >
          <img :src="item.icon" alt="icon" class="banner-icon" />
          <span :class="$i18n.locale === 'ar' ? 'arabic-text' : ''">
            {{ $t(item.label) }}
          </span>
        </span>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'ScrollingBanner',
    data() {
      return {
        items: [
          {
            label: 'banner_highlight_text_1',
            icon: require('../assets/images/banner-icons/family.svg'),
          },
          {
            label: 'banner_highlight_text_2',
            icon: require('../assets/images/banner-icons/rocket.svg'),
          },
          {
            label: 'banner_highlight_text_3',
            icon: require('../assets/images/banner-icons/gift.svg'),
          },
          {
            label: 'banner_highlight_text_4',
            icon: require('../assets/images/banner-icons/Book.svg'),
          },
        ],
        repeatCount: 70, // Adjust based on screen width
        duration: 1500, // Slow and smooth
      };
    },
    computed: {
      repeatedItems() {
        const result = [];
        for (let i = 0; i < this.repeatCount; i++) {
          result.push(...this.items);
        }
        return result;
      },
    },
  };
  </script>
<style scoped>
.banner-wrapper {
  overflow: hidden;
  white-space: nowrap;
  background-color: #FFA726;
  color: #020076;
  font-weight: bold;
  font-size: 12px;
  height: 30px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-family: "Nunito-Regular", sans-serif;
}

.banner-content {
  display: inline-flex;
  white-space: nowrap;
  padding-left: 5%;
  animation: scroll-left linear infinite;
  will-change: transform;
  backface-visibility: hidden;
  font-size: 0.8rem;
  padding-block: 15px;
  align-items: center;
}

.banner-item {
  display: inline-flex;
  align-items: center;
  margin-right: 80px;
}

.banner-icon {
  height: 15px;
  width: 15px;
  margin-right: 5px;
  vertical-align: middle;
  margin-top: -2px;
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.arabic-text {
  direction: rtl;
  font-family: "Cairo", sans-serif;
}
</style>